import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { passwordValidator } from 'app/shared/guards/password-equal.validator';
import { AuthService } from 'app/shared/services/auth.service';
import { UserService } from 'app/shared/services/user.service';


@Component({
  selector: 'ngx-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  
  loginForm: FormGroup;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  resetPwdData : any;

  invalidMessage =null;
  isInvalidData = false;
  errorMessage = '';
  roles: string[] = [];

  validationMessages = {
    'username': { 'required': 'Username is required' },
    'newPassword': { 'required': 'New password is required' },
    'confirmPassword': { 'required': 'Confirm password is required' },
    'passwordGroup' : {'passowrdMismatch' :'Password and Confirm password does not match'}, 
  };

  formErrors = {
    'username': "",
    'newPassword': "",
    'confirmPassword': "",
    'passwordGroup': "",
  };

  constructor (
    private fb: FormBuilder,
    private router : Router,
    private authService: AuthService,
    private route : ActivatedRoute,
    private toastr: ToastrService,
    private userService : UserService,
    ) { }

  ngOnInit() {

    this.loginForm = this.fb.group({
      id : [''],  
      username : ['', Validators.required],  
      passwordGroup : this.fb.group({
        newPassword : ['',Validators.required],
        confirmPassword : ['',Validators.required],
      },{validators: passwordValidator})     
    });

    this.resetPwdData ={
      id: '',
      newPassword : '',
      username : ''
  
    }

    this.getRowData();

    this.loginForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.loginForm);
    });

  }

  backToRequestList(){
    this.router.navigate(['/pages/user-management/reset-password-request-list']);
    }

    mapFormValuesToModel(){
      this.resetPwdData.id=this.loginForm.value.id;
      this.resetPwdData.username=this.loginForm.value.username;
      this.resetPwdData.newPassword=this.loginForm.get('passwordGroup.newPassword').value; 
    }

  onSubmit() {
    this.mapFormValuesToModel();
    this.showProcessingIndicator = true; 
        this.userService.resetPassword(this.resetPwdData).subscribe(
        (res) => {

          if(res.success===2){
            this.toastr.error('Entered username is invalid','Warning');
            this.showProcessingIndicator = false; 

          }else{
            this.toastr.success('Password reset successfully','Success');
            this.showProcessingIndicator = false; 
            this.loginForm.reset();  
          }
                                                           

          },        
        (err) =>  {
            this.toastr.error('Failed to reset password');                            
            this.showProcessingIndicator = false;
            console.log(err);
          }, 
        )
  }



   logValidationErrors(group: FormGroup = this.loginForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      this.invalidMessage = null;
      if(isDirty)
      {
        this.loginForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  getRowData(){
    var data  = this.userService.resetRequestDataRow;
    if(data){
      this.loginForm.patchValue({
        id : data.Id,  
        username : data.Username,         
      });
    }
                         
  }


} // end class
